import { useTranslation } from 'react-i18next';

export function useMenus() {
  const { t } = useTranslation();
  return [
    {
      href: '/',
      logo: 'home',
      label: t('menu./.label'),
    },
    {
      href: '/url-encode',
      logo: 'url',
      label: t('menu./url-encode.label'),
    },
    {
      href: '/json-format',
      logo: 'json',
      label: t('menu./json-format.label'),
    },
    {
      href: '/js-beautifier',
      logo: 'js',
      label: t('menu./js-beautifier.label'),
    },
    {
      href: '/js-obfuscator',
      logo: 'js',
      label: t('menu./js-obfuscator.label'),
    },
    {
      href: '/text-case',
      logo: 'text',
      label: t('menu./text-case.label'),
    },
    {
      href: '/image-to-base64',
      logo: 'image',
      label: t('menu./image-to-base64.label'),
    },
    {
      href: '/code-to-image',
      logo: 'code-image',
      label: t('menu./code-to-image.label'),
    },
    {
      href: '/hash',
      logo: 'hash',
      label: t('menu./hash.label'),
    },
    {
      href: '/generate-password',
      logo: 'password',
      label: t('menu./generate-password.label'),
    },
    {
      href: '/html-formatter',
      logo: 'html5',
      label: t('menu./html-formatter.label'),
    },
    {
      href: '/html-escape',
      logo: 'html5',
      label: t('menu./html-escape.label'),
    },
    {
      href: '/html-to-markdown',
      logo: 'markdown',
      label: t('menu./html-to-markdown.label'),
    },
    {
      href: '/markdown-to-html',
      logo: 'html5',
      label: t('menu./markdown-to-html.label'),
    },
    {
      href: '/base64-encoder',
      logo: 'base64',
      label: t('menu./base64-encoder.label'),
    },
    {
      href: '/qrcode-generator',
      logo: 'qrcode',
      label: t('menu./qrcode-generator.label'),
    },
    {
      href: '/chinese-pinyin-conversion',
      logo: 'pinyin',
      label: t('menu./chinese-pinyin-conversion.label'),
    },
    {
      href: '/generate-github-badges',
      logo: 'github',
      label: t('menu./generate-github-badges.label'),
    },
    {
      href: '/toml-to-json',
      logo: 'toml',
      label: t('menu./toml-to-json.label'),
    },
    {
      href: '/css-easing-animation',
      logo: 'css3',
      label: t('menu./css-easing-animation.label'),
    },
    {
      href: '/css-formatter',
      logo: 'css3',
      label: t('menu./css-formatter.label'),
    },
    {
      href: '/simple-markdown-editor',
      logo: 'markdown',
      label: t('menu./simple-markdown-editor.label'),
    },
    {
      href: '/jwt-decoder',
      logo: 'jwt',
      label: t('menu./jwt-decoder.label'),
    },
    {
      href: '/json-yaml',
      logo: 'yaml',
      label: t('menu./json-yaml.label'),
    },
    {
      href: '/json-xml',
      logo: 'xml',
      label: t('menu./json-xml.label'),
    },
    {
      href: '/json-ini',
      logo: 'ini',
      label: t('menu./json-ini.label'),
    },
    {
      href: '/pdf-to-img',
      logo: 'pdf',
      label: t('menu./pdf-to-img.label'),
    },
    {
      href: '/exif-viewer',
      logo: 'image',
      label: t('menu./exif-viewer.label'),
    },
    {
      href: '/svg-optimizer',
      logo: 'svg',
      label: t('menu./svg-optimizer.label'),
    },
    {
      href: '/amount-in-rmb',
      logo: 'rmb',
      label: t('menu./amount-in-rmb.label'),
    },
    {
      href: '/standard-chinese-characters',
      logo: 'hans',
      label: t('menu./standard-chinese-characters.label'),
    },
    {
      href: '/simplified-traditional-chinese',
      logo: 'traditional-chinese',
      label: t('menu./simplified-traditional-chinese.label'),
    },
    {
      divider: true,
    },
    {
      href: 'https://badgen.net/',
      'open-source': 'https://github.com/badgen/badgen.net',
      logo: 'badgen',
      about: t('menu.Badgen.about'),
      label: t('menu.Badgen.label'),
    },
    {
      href: 'https://codesandbox.io',
      'open-source': 'https://github.com/codesandbox/codesandbox-client',
      logo: 'codesandbox',
      about: t('menu.CodeSandbox.about'),
      label: t('menu.CodeSandbox.label'),
    },
    {
      href: 'https://codeimg.io/',
      about: t('menu.Codeimg.about'),
      label: t('menu.Codeimg.label'),
    },
    {
      href: 'https://chalk.ist/',
      logo: 'chalk.ist.png',
      'open-source': 'https://github.com/Idered/chalk.ist',
      about: t('menu.Chalkist.about'),
      label: t('menu.Chalkist.label'),
    },
    {
      href: 'https://codepen.io',
      logo: 'codepen',
      about: t('menu.CodePen.about'),
      label: t('menu.CodePen.label'),
    },
    {
      href: 'https://excalidraw.com/',
      'open-source': 'https://github.com/excalidraw/excalidraw',
      about: t('menu.Excalidraw.about'),
      label: t('menu.Excalidraw.label'),
    },
    {
      href: 'https://easings.net',
      logo: 'easing-functions-cheat-sheet',
      about: t('menu.easings.about'),
      label: t('menu.easings.label'),
    },
    {
      href: 'https://kangax.github.io/compat-table/es6/',
      'open-source': 'https://github.com/kangax/compat-table',
      logo: 'ecmascript-6-compatibility-table',
      about: t('menu.compat-table.about'),
      label: t('menu.compat-table.label'),
    },
    {
      href: 'https://buttons.github.io',
      'open-source': 'https://github.com/ntkme/github-buttons',
      about: t('menu.GithubButtons.about'),
      label: t('menu.GithubButtons.label'),
    },
    {
      href: 'https://ihateregex.io/',
      'open-source': 'https://github.com/aykutkardas/regexlearn.com',
      about: t('menu.iHateRegex.about'),
      label: t('menu.iHateRegex.label'),
    },
    {
      href: 'https://jsfiddle.net',
      about: t('menu.JSFiddle.about'),
      label: t('menu.JSFiddle.label'),
    },
    {
      href: 'https://jsbin.com',
      about: t('menu.JSBin.about'),
      label: t('menu.JSBin.label'),
    },
    {
      href: 'https://jshint.com',
      about: t('menu.JSHint.about'),
      label: t('menu.JSHint.label'),
    },
    {
      href: 'https://uiwjs.github.io/json-viewer/',
      about: t('menu.JSONViewer.about'),
      label: t('menu.JSONViewer.label'),
    },
    {
      href: 'https://uiwjs.github.io/keycode-info/',
      about: t('menu.KeycodeInfo.about'),
      label: t('menu.KeycodeInfo.label'),
    },
    {
      href: 'https://regexlearn.com/',
      'open-source': 'https://github.com/aykutkardas/regexlearn.com',
      about: t('menu.LearnRegEx.about'),
      label: t('menu.LearnRegEx.label'),
    },
    {
      href: 'https://jaywcjlove.github.io/logo/',
      about: t('menu.LogoAsset.about'),
      label: t('menu.LogoAsset.label'),
    },
    {
      href: 'https://npmview.vercel.app',
      'open-source': 'https://github.com/pd4d10/npmview',
      about: t('menu.NPMView.about'),
      label: t('menu.NPMView.label'),
    },
    {
      href: 'https://uiwjs.github.io/npm-unpkg/',
      about: t('menu.NPMUnpkg.about'),
      label: t('menu.NPMUnpkg.label'),
    },
    {
      href: 'https://jaywcjlove.github.io/nginx-editor/',
      logo: 'nginx',
      about: t('menu.NginxEditor.about'),
      label: t('menu.NginxEditor.label'),
    },
    {
      href: 'https://www.pixelartcss.com/',
      logo: 'pixel-art-to-css.png',
      'open-source': 'https://github.com/jvalen/pixel-art-react',
      about: t('menu.PixelArttoCSS.about'),
      label: t('menu.PixelArttoCSS.label'),
    },
    {
      href: 'https://playcode.io',
      about: t('menu.PlayCode.about'),
      label: t('menu.PlayCode.label'),
    },
    {
      href: 'https://app.quicktype.io',
      'open-source': 'https://github.com/quicktype/quicktype',
      about: t('menu.Quicktype.about'),
      label: t('menu.Quicktype.label'),
    },
    {
      href: 'https://jaywcjlove.github.io/regexp-example/',
      about: t('menu.RegexpExample.about'),
      label: t('menu.RegexpExample.label'),
    },
    {
      href: 'https://jex.im/regulex/',
      logo: 'regulex.png',
      'open-source': 'https://github.com/CJex/regulex',
      about: t('menu.Regulex.about'),
      label: t('menu.Regulex.label'),
    },
    {
      href: 'https://regex101.com/',
      logo: 'regex101.png',
      'open-source': 'https://github.com/firasdib/Regex101',
      about: t('menu.Regex101.about'),
      label: t('menu.Regex101.label'),
    },
    {
      href: 'https://uiwjs.github.io/react-run-web/',
      about: t('menu.RunWeb.about'),
      label: t('menu.RunWeb.label'),
    },
    {
      href: 'https://rubular.com/',
      logo: 'rubular.png',
      about: t('menu.Rubular.about'),
      label: t('menu.Rubular.label'),
    },
    {
      href: 'http://regexr.com/',
      'open-source': 'https://github.com/gskinner/regexr',
      about: t('menu.RegExr.about'),
      label: t('menu.RegExr.label'),
    },
    {
      href: 'https://regex-vis.com/',
      'open-source': 'https://github.com/Bowen7/regex-vis',
      about: t('menu.RegexVis.about'),
      label: t('menu.RegexVis.label'),
    },
    {
      href: 'https://pengfeiw.github.io/minicode/react-paint',
      'open-source': 'https://github.com/pengfeiw/react-paint',
      about: t('menu.ReactPaint.about'),
      label: t('menu.ReactPaint.label'),
    },
    {
      href: 'https://runkit.com',
      about: t('menu.RunKit.about'),
      label: t('menu.RunKit.label'),
    },
    {
      href: 'https://ray.so/',
      logo: 'ray.so.png',
      about: t('menu.Rayso.about'),
      label: t('menu.Rayso.label'),
    },
    {
      href: 'https://redketchup.io/icon-editor',
      logo: 'redketchup.io.png',
      about: t('menu.redketchup.about'),
      label: t('menu.redketchup.label'),
    },
    {
      href: 'https://unpkg.com/svgedit@7.1.3/dist/editor/index.html',
      logo: 'svg-edit',
      'open-source': 'https://github.com/SVG-Edit/svgedit',
      about: t('menu.SVGEdit.about'),
      label: t('menu.SVGEdit.label'),
    },
    {
      href: 'https://yqnn.github.io/svg-path-editor/',
      logo: 'svg-edit',
      about: t('menu.SVGPathEditor.about'),
      label: t('menu.SVGPathEditor.label'),
    },
    {
      href: 'https://shields.io/',
      logo: 'shields.io.png',
      'open-source': 'https://github.com/badges/shields',
      about: t('menu.Shields.about'),
      label: t('menu.Shields.label'),
    },
    {
      href: 'https://stackblitz.com',
      logo: 'stackblitz.png',
      about: t('menu.StackBlitz.about'),
      label: t('menu.StackBlitz.label'),
    },
    {
      href: 'https://skillicons.dev/',
      'open-source': 'https://github.com/tandpfun/skill-icons',
      about: t('menu.SkillIcons.about'),
      label: t('menu.SkillIcons.label'),
    },
    {
      href: 'https://starchart.cc/',
      about: t('menu.StarChart.about'),
      label: t('menu.StarChart.label'),
    },
    {
      href: 'https://sketchpad.app/',
      logo: 'sketchpad.png',
      about: t('menu.sketchpad.about'),
      label: t('menu.sketchpad.label'),
    },
    {
      href: 'https://uiwjs.github.io/ui-color/',
      about: t('menu.UIColor.about'),
      label: t('menu.UIColor.label'),
    },
    {
      href: 'https://jspaint.app',
      'open-source': 'https://github.com/1j01/jspaint',
      logo: 'jspaint.png',
      about: t('menu.jspaint.about'),
      label: t('menu.jspaint.label'),
    },
  ];
}
